import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./ContactModal.css";
import Api from "../service/Api";

const ContactModal = ({ open, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    whatsapp: "",
    contact: "",
    company: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
  }, [open]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    try {
      const response = await Api.sendMail(formData);

      if (response.data.success) {
        alert("Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          whatsapp: "",
          contact: "",
          company: "",
          message: "",
        });
        onClose();
      } else {
        throw new Error(response.data.message || "Failed to send message");
      }
    } catch (error) {
      console.error(error);
      alert("There was an error sending your message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <motion.div
        className="bottom-sheet"
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        exit={{ y: "100%" }}
        transition={{ type: "spring", damping: 25, stiffness: 250 }}
        drag="y"
        dragConstraints={{ top: 0, bottom: 200 }}
        dragElastic={0.2}
        onDragEnd={(e, info) => {
          if (info.offset.y > 120) onClose();
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sheet-header">
          <div className="drag-handle" />
          <h3>Contact Us</h3>
          <p className="sheet-subtitle">
            We’ll get back to you within 24 hours
          </p>
        </div>

        <form className="sheet-form" onSubmit={handleSubmit}>
          <input
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="whatsapp"
            placeholder="WhatsApp Number"
            value={formData.whatsapp}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="contact"
            placeholder="Contact Number"
            value={formData.contact}
            onChange={handleChange}
          />
          <input
            name="company"
            placeholder="Company Name"
            value={formData.company}
            onChange={handleChange}
          />

          <textarea
            rows="4"
            name="message"
            placeholder="Your Message / Requirement"
            value={formData.message}
            onChange={handleChange}
          />

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default ContactModal;
